import React, { useState, useEffect } from 'react';
import "../styles.scss";

const Select = (props) => {
    const { option, answer, setAnswer, isSingle, onAnswer, questionIndex } = props;

    return (
        <div className="disabled-question text-center">
            {option.label}
        </div>
    )
}

export default Select;